<template>
  <Configuration :items="items" :width="1269" :height="445">
    <template v-slot:base>
      <svg
        class="base"
        fill="none"
        width="1440"
        height="900"
        viewBox="0 0 1440 900"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1440 0H0V900H1440V0Z" fill="#F7FAFC" />
        <path
          d="M1285.57 126.04H154.43V155.22H1285.57V126.04Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.16 281.97H626.83V294.84H638.16V281.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M632.49 290.34C633.633 290.34 634.56 289.413 634.56 288.27C634.56 287.127 633.633 286.2 632.49 286.2C631.347 286.2 630.42 287.127 630.42 288.27C630.42 289.413 631.347 290.34 632.49 290.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M691.05 281.97H679.72V294.84H691.05V281.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M685.39 290.34C686.533 290.34 687.46 289.413 687.46 288.27C687.46 287.127 686.533 286.2 685.39 286.2C684.247 286.2 683.32 287.127 683.32 288.27C683.32 289.413 684.247 290.34 685.39 290.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.16 397.64H626.83V410.51H638.16V397.64Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M632.49 406.28C633.633 406.28 634.56 405.353 634.56 404.21C634.56 403.067 633.633 402.14 632.49 402.14C631.347 402.14 630.42 403.067 630.42 404.21C630.42 405.353 631.347 406.28 632.49 406.28Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M690.78 397.64H679.45V410.51H690.78V397.64Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M685.39 406.28C686.533 406.28 687.46 405.353 687.46 404.21C687.46 403.067 686.533 402.14 685.39 402.14C684.247 402.14 683.32 403.067 683.32 404.21C683.32 405.353 684.247 406.28 685.39 406.28Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter0_d_865_87)">
          <path
            d="M694.03 294.84H622.21C619.951 294.84 618.12 296.671 618.12 298.93V393.55C618.12 395.809 619.951 397.64 622.21 397.64H694.03C696.289 397.64 698.12 395.809 698.12 393.55V298.93C698.12 296.671 696.289 294.84 694.03 294.84Z"
            fill="#F7FAFC"
          />
          <path
            d="M694.03 294.84H622.21C619.951 294.84 618.12 296.671 618.12 298.93V393.55C618.12 395.809 619.951 397.64 622.21 397.64H694.03C696.289 397.64 698.12 395.809 698.12 393.55V298.93C698.12 296.671 696.289 294.84 694.03 294.84Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M695.11 298.92V393.54C695.11 394.14 694.62 394.63 694.02 394.63H622.19C621.59 394.63 621.1 394.14 621.1 393.54V298.92C621.1 298.32 621.59 297.83 622.19 297.83H694.02C694.62 297.83 695.11 298.32 695.11 298.92Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M689.93 301.29H626.31V391.18H689.93V301.29Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.17 344.44H628.9V352.65H638.17V344.44Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M629.77 348.55V349.49H630.63V350.59H631.56V351.69H635.35V350.53H637.28V348.55V346.57H635.35V345.41H631.56V346.5H630.63V347.6H629.77V348.55Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.17 354.88H628.9V363.09H638.17V354.88Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M629.77 358.99V359.94H630.63V361.04H631.56V362.13H635.35V360.97H637.28V358.99V357.01H635.35V355.85H631.56V356.95H630.63V358.05H629.77V358.99Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.17 365.33H628.9V373.54H638.17V365.33Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M629.77 369.43V370.38H630.63V371.48H631.56V372.58H635.35V371.41H637.28V369.43V367.45H635.35V366.29H631.56V367.39H630.63V368.49H629.77V369.43Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M638.17 375.77H628.9V383.98H638.17V375.77Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M629.77 379.88V380.82H630.63V381.92H631.56V383.02H635.35V381.86H637.28V379.88V377.89H635.35V376.73H631.56V377.83H630.63V378.93H629.77V379.88Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M677.74 352.66H687.01V344.45H677.74V352.66Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.13 348.55V349.49H685.28V350.59H684.35V351.69H680.56V350.53H678.62V348.55V346.57H680.56V345.41H684.35V346.5H685.28V347.6H686.13V348.55Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M677.74 363.1H687.01V354.89H677.74V363.1Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.13 358.99V359.94H685.28V361.04H684.35V362.13H680.56V360.97H678.62V358.99V357.01H680.56V355.85H684.35V356.95H685.28V358.05H686.13V358.99Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M677.74 373.54H687.01V365.33H677.74V373.54Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.13 369.43V370.38H685.28V371.48H684.35V372.58H680.56V371.41H678.62V369.43V367.45H680.56V366.29H684.35V367.39H685.28V368.49H686.13V369.43Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M677.74 383.98H687.01V375.77H677.74V383.98Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.13 379.88V380.82H685.28V381.92H684.35V383.02H680.56V381.86H678.62V379.88V377.89H680.56V376.73H684.35V377.83H685.28V378.93H686.13V379.88Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M645.48 346.82H640.6V348.97H645.48V346.82Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M645.48 350.97H640.6V353.12H645.48V350.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M645.48 355.12H640.6V357.27H645.48V355.12Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M645.48 359.27H640.6V361.42H645.48V359.27Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M643.41 365.36H640.6V373.73H643.41V365.36Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M648.89 334.03H646.08V338.21H648.89V334.03Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M662.74 320.08H662.73C661.957 320.08 661.33 320.707 661.33 321.48V327.05C661.33 327.823 661.957 328.45 662.73 328.45H662.74C663.513 328.45 664.14 327.823 664.14 327.05V321.48C664.14 320.707 663.513 320.08 662.74 320.08Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M644.45 375.66H640.6V377.81H644.45V375.66Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M650.67 375.66H646.82V377.81H650.67V375.66Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M644.45 379.81H640.6V381.96H644.45V379.81Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M650.67 379.81H646.82V381.96H650.67V379.81Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M652.09 325.16V313.8H640.73V325.16H652.09Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M650.32 315.57H642.49V323.4H650.32V315.57Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M669.48 348.1H664.58V355.82H669.48V348.1Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M655.68 357.43H652.2V369.42H655.68V357.43Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M661.56 357.43H658.08V369.42H661.56V357.43Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M661.74 371.53H658.17V381.86H661.74V371.53Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M629.2 316.76V320.33H638.16V316.76H629.2Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M666.2 372.57H664.71V382.9H666.2V372.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M669.31 372.57H667.82V382.9H669.31V372.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M672.42 372.57H670.93V382.9H672.42V372.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M675.53 372.57H674.04V382.9H675.53V372.57Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M668.39 346.14V344.59H665.68V346.14H668.39Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M675.83 348.1H670.93V355.82H675.83V348.1Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M674.79 334.34H670.93V338.2H674.79V334.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.31 334.34H680.45V338.2H684.31V334.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M674.74 346.15V344.6H672.03V346.15H674.74Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M669.48 361.57H664.58V369.29H669.48V361.57Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M668.39 359.61V358.06H665.68V359.61H668.39Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M675.83 361.57H670.93V369.29H675.83V361.57Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M674.74 359.62V358.07H672.03V359.62H674.74Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M661.81 353.2H660.26V355.91H661.81V353.2Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M650.22 356.71H648.67V360.46H650.22V356.71Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M658.78 328.45V326.9H656.07V328.45H658.78Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 311.62H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 312.89H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 314.17H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 315.44H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 316.71H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.55 310.35H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M660.9 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M659.62 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M658.35 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M657.08 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M655.8 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M662.17 308.1V318.97"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M663.34 309.21H654.63V317.85H663.34V309.21Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M677.38 309.21H667.64V317.85H677.38V309.21Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M647.49 332.68C649.141 332.68 650.48 331.341 650.48 329.69C650.48 328.039 649.141 326.7 647.49 326.7C645.839 326.7 644.5 328.039 644.5 329.69C644.5 331.341 645.839 332.68 647.49 332.68Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M633.01 325.66C634.661 325.66 636 324.993 636 324.17C636 323.347 634.661 322.68 633.01 322.68C631.359 322.68 630.02 323.347 630.02 324.17C630.02 324.993 631.359 325.66 633.01 325.66Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.64 338.11C654.767 338.11 655.68 337.197 655.68 336.07C655.68 334.943 654.767 334.03 653.64 334.03C652.513 334.03 651.6 334.943 651.6 336.07C651.6 337.197 652.513 338.11 653.64 338.11Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M637.86 311.29V307.64H629.2V311.29H637.86Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M637.87 314.94V311.29H629.21V314.94H637.87Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M633.01 311.28V307.63H629.2V311.28H633.01Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M630.22 310.26H631.99V308.66H630.22V310.26Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M633.01 314.93V311.28H629.2V314.93H633.01Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M630.22 313.91H631.99V312.31H630.22V313.91Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M637.86 311.29V307.64H635.86V311.29H637.86Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M637.86 314.93V311.28H635.86V314.93H637.86Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.75 312.87V309.22H679.09V312.87H687.75Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.75 316.52V312.87H679.09V316.52H687.75Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.97 312.87V309.22H681.16V312.87H684.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 311.85H683.94V310.25H682.17V311.85Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.97 316.52V312.87H681.16V316.52H684.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 315.5H683.94V313.9H682.17V315.5Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.74 320.17V316.52H679.08V320.17H687.74Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.97 320.17V316.52H681.16V320.17H684.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 319.14H683.94V317.54H682.17V319.14Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.74 325.3V321.65H679.08V325.3H687.74Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.75 328.95V325.3H679.09V328.95H687.75Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.97 325.31V321.66H681.16V325.31H684.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 324.28H683.94V322.68H682.17V324.28Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.97 328.95V325.3H681.16V328.95H684.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 327.93H683.94V326.33H682.17V327.93Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M687.75 332.6V328.95H679.09V332.6H687.75Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M684.96 332.6V328.95H681.15V332.6H684.96Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.17 331.58H683.94V329.98H682.17V331.58Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M633.58 340.89C636.314 340.89 638.53 338.674 638.53 335.94C638.53 333.206 636.314 330.99 633.58 330.99C630.846 330.99 628.63 333.206 628.63 335.94C628.63 338.674 630.846 340.89 633.58 340.89Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M633.58 337.02C634.176 337.02 634.66 336.536 634.66 335.94C634.66 335.344 634.176 334.86 633.58 334.86C632.984 334.86 632.5 335.344 632.5 335.94C632.5 336.536 632.984 337.02 633.58 337.02Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M641.43 342.66H656.06"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M653.84 345.31V340.02H643.51V345.31H653.84Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M664.52 330.72H660.95V341.05H664.52V330.72Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M660.95 339.09H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M660.95 337.02H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M660.95 334.95H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M660.95 332.88H664.42"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M622.85 386.08C622.85 398.2 642.19 383.99 642.19 398.68"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M692.77 386.08C692.77 398.2 672.48 383.99 672.48 398.68"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M628.9 379.81C623.67 379.81 622.85 382.68 622.85 386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.72 379.81C691.95 379.81 692.77 382.68 692.77 386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M628.9 369.42C623.67 369.42 622.85 372.29 622.85 375.69V386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M622.85 386.08V365.27C622.85 361.87 623.67 359 628.9 359"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M628.9 348.55C623.67 348.55 622.85 351.42 622.85 354.82V386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.72 369.42C691.95 369.42 692.77 372.29 692.77 375.69V386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M692.77 386.08V365.27C692.77 361.87 691.95 359 686.72 359"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M686.72 348.55C691.95 348.55 692.77 351.42 692.77 354.82V386.08"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1029.76 107.66V506.09H864.65C860.65 506.09 857.4 509.34 857.4 513.34V535.14H867.12V515.81H1032.49C1036.36 515.81 1039.49 512.68 1039.49 508.81V107.66H1029.77H1029.76Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M758.17 477.07H854.69C856.347 477.07 857.69 475.727 857.69 474.07V440.78C857.69 439.123 856.347 437.78 854.69 437.78H758.17C756.513 437.78 755.17 439.123 755.17 440.78V474.07C755.17 475.727 756.513 477.07 758.17 477.07Z"
          fill="#BCBEC0"
        />
        <path
          d="M452.3 401.23H485.59C487.247 401.23 488.59 399.887 488.59 398.23V364.94C488.59 363.283 487.247 361.94 485.59 361.94H452.3C450.643 361.94 449.3 363.283 449.3 364.94V398.23C449.3 399.887 450.643 401.23 452.3 401.23Z"
          fill="#BCBEC0"
        />
        <path
          d="M705.45 567.96H738.74C740.397 567.96 741.74 566.617 741.74 564.96V531.67C741.74 530.013 740.397 528.67 738.74 528.67H705.45C703.793 528.67 702.45 530.013 702.45 531.67V564.96C702.45 566.617 703.793 567.96 705.45 567.96Z"
          fill="#BCBEC0"
        />
        <path
          d="M452.51 225.97H485.8C487.457 225.97 488.8 224.627 488.8 222.97V189.68C488.8 188.023 487.457 186.68 485.8 186.68H452.51C450.853 186.68 449.51 188.023 449.51 189.68V222.97C449.51 224.627 450.853 225.97 452.51 225.97Z"
          fill="#BCBEC0"
        />
        <g filter="url(#filter1_d_865_87)">
          <path
            d="M887.18 297.93H790.76C787.999 297.93 785.76 300.169 785.76 302.93V361.95C785.76 364.711 787.999 366.95 790.76 366.95H887.18C889.941 366.95 892.18 364.711 892.18 361.95V302.93C892.18 300.169 889.941 297.93 887.18 297.93Z"
            fill="#F7FAFC"
          />
          <path
            d="M887.18 297.93H790.76C787.999 297.93 785.76 300.169 785.76 302.93V361.95C785.76 364.711 787.999 366.95 790.76 366.95H887.18C889.941 366.95 892.18 364.711 892.18 361.95V302.93C892.18 300.169 889.941 297.93 887.18 297.93Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter2_d_865_87)">
          <path
            d="M802.7 297.74H875.24V374.69C875.24 375.79 874.34 376.69 873.24 376.69H804.7C803.6 376.69 802.7 375.79 802.7 374.69V297.74Z"
            fill="#F7FAFC"
          />
          <path
            d="M802.7 297.74H875.24V374.69C875.24 375.79 874.34 376.69 873.24 376.69H804.7C803.6 376.69 802.7 375.79 802.7 374.69V297.74Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M884.92 309.04C886.047 309.04 886.96 308.127 886.96 307C886.96 305.873 886.047 304.96 884.92 304.96C883.793 304.96 882.88 305.873 882.88 307C882.88 308.127 883.793 309.04 884.92 309.04Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M793.02 309.04C794.147 309.04 795.06 308.127 795.06 307C795.06 305.873 794.147 304.96 793.02 304.96C791.893 304.96 790.98 305.873 790.98 307C790.98 308.127 791.893 309.04 793.02 309.04Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M884.92 363.54C886.047 363.54 886.96 362.627 886.96 361.5C886.96 360.373 886.047 359.46 884.92 359.46C883.793 359.46 882.88 360.373 882.88 361.5C882.88 362.627 883.793 363.54 884.92 363.54Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M793.02 363.54C794.147 363.54 795.06 362.627 795.06 361.5C795.06 360.373 794.147 359.46 793.02 359.46C791.893 359.46 790.98 360.373 790.98 361.5C790.98 362.627 791.893 363.54 793.02 363.54Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter3_d_865_87)">
          <path d="M860.13 305.43H851.46V360.93H860.13V305.43Z" fill="#F7FAFC" />
          <path
            d="M860.13 305.43H851.46V360.93H860.13V305.43Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter4_d_865_87)">
          <path d="M826 305.43H817.33V360.93H826V305.43Z" fill="#F7FAFC" />
          <path
            d="M826 305.43H817.33V360.93H826V305.43Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter5_d_865_87)">
          <path d="M871.3 315.43H806.41V322.59H871.3V315.43Z" fill="#F7FAFC" />
          <path
            d="M871.3 315.43H806.41V322.59H871.3V315.43Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter6_d_865_87)">
          <path
            d="M828.86 309.84H814.52C813.415 309.84 812.52 310.735 812.52 311.84V326.18C812.52 327.285 813.415 328.18 814.52 328.18H828.86C829.965 328.18 830.86 327.285 830.86 326.18V311.84C830.86 310.735 829.965 309.84 828.86 309.84Z"
            fill="#F7FAFC"
          />
          <path
            d="M828.86 309.84H814.52C813.415 309.84 812.52 310.735 812.52 311.84V326.18C812.52 327.285 813.415 328.18 814.52 328.18H828.86C829.965 328.18 830.86 327.285 830.86 326.18V311.84C830.86 310.735 829.965 309.84 828.86 309.84Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter7_d_865_87)">
          <path
            d="M863.05 309.84H848.71C847.605 309.84 846.71 310.735 846.71 311.84V326.18C846.71 327.285 847.605 328.18 848.71 328.18H863.05C864.154 328.18 865.05 327.285 865.05 326.18V311.84C865.05 310.735 864.154 309.84 863.05 309.84Z"
            fill="#F7FAFC"
          />
          <path
            d="M863.05 309.84H848.71C847.605 309.84 846.71 310.735 846.71 311.84V326.18C846.71 327.285 847.605 328.18 848.71 328.18H863.05C864.154 328.18 865.05 327.285 865.05 326.18V311.84C865.05 310.735 864.154 309.84 863.05 309.84Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter8_d_865_87)">
          <path
            d="M834.15 321.73L838.87 324.46L843.59 321.73V316.28L838.87 313.55L834.15 316.28V321.73Z"
            fill="#F7FAFC"
          />
          <path
            d="M834.15 321.73L838.87 324.46L843.59 321.73V316.28L838.87 313.55L834.15 316.28V321.73Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M821.69 326.9C826.048 326.9 829.58 323.368 829.58 319.01C829.58 314.652 826.048 311.12 821.69 311.12C817.333 311.12 813.8 314.652 813.8 319.01C813.8 323.368 817.333 326.9 821.69 326.9Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M855.88 326.9C860.238 326.9 863.77 323.368 863.77 319.01C863.77 314.652 860.238 311.12 855.88 311.12C851.522 311.12 847.99 314.652 847.99 319.01C847.99 323.368 851.522 326.9 855.88 326.9Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter9_d_865_87)">
          <path
            d="M868.77 333.78H855.95C849.9 333.78 844.99 338.69 844.99 344.74C844.99 346.13 845.26 347.46 845.73 348.68H843.13V355.7H855.95C862 355.7 866.91 350.79 866.91 344.74C866.91 343.35 866.64 342.02 866.17 340.8H868.77V333.78Z"
            fill="#F7FAFC"
          />
          <path
            d="M868.77 333.78H855.95C849.9 333.78 844.99 338.69 844.99 344.74C844.99 346.13 845.26 347.46 845.73 348.68H843.13V355.7H855.95C862 355.7 866.91 350.79 866.91 344.74C866.91 343.35 866.64 342.02 866.17 340.8H868.77V333.78Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter10_d_865_87)">
          <path
            d="M855.95 355.7C862.003 355.7 866.91 350.793 866.91 344.74C866.91 338.687 862.003 333.78 855.95 333.78C849.897 333.78 844.99 338.687 844.99 344.74C844.99 350.793 849.897 355.7 855.95 355.7Z"
            fill="#F7FAFC"
          />
          <path
            d="M855.95 355.7C862.003 355.7 866.91 350.793 866.91 344.74C866.91 338.687 862.003 333.78 855.95 333.78C849.897 333.78 844.99 338.687 844.99 344.74C844.99 350.793 849.897 355.7 855.95 355.7Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M850.49 339.28L861.41 350.2"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M861.41 339.28L850.49 350.2"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter11_d_865_87)">
          <path
            d="M834.5 333.78H821.68C815.63 333.78 810.72 338.69 810.72 344.74C810.72 346.13 810.99 347.46 811.46 348.68H808.86V355.7H821.68C827.73 355.7 832.64 350.79 832.64 344.74C832.64 343.35 832.37 342.02 831.9 340.8H834.5V333.78Z"
            fill="#F7FAFC"
          />
          <path
            d="M834.5 333.78H821.68C815.63 333.78 810.72 338.69 810.72 344.74C810.72 346.13 810.99 347.46 811.46 348.68H808.86V355.7H821.68C827.73 355.7 832.64 350.79 832.64 344.74C832.64 343.35 832.37 342.02 831.9 340.8H834.5V333.78Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter12_d_865_87)">
          <path
            d="M821.69 355.7C827.743 355.7 832.65 350.793 832.65 344.74C832.65 338.687 827.743 333.78 821.69 333.78C815.637 333.78 810.73 338.687 810.73 344.74C810.73 350.793 815.637 355.7 821.69 355.7Z"
            fill="#F7FAFC"
          />
          <path
            d="M821.69 355.7C827.743 355.7 832.65 350.793 832.65 344.74C832.65 338.687 827.743 333.78 821.69 333.78C815.637 333.78 810.73 338.687 810.73 344.74C810.73 350.793 815.637 355.7 821.69 355.7Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M816.23 339.28L827.15 350.2"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M827.15 339.28L816.23 350.2"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M642.19 398.67V486.33C642.19 491.85 646.67 496.33 652.19 496.33H756.81"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M642.19 450.66V538.32C642.19 543.84 646.67 548.32 652.19 548.32H722.09"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M469.03 381.58V486.32C469.03 491.84 473.51 496.32 479.03 496.32H632.19C637.71 496.32 642.19 491.84 642.19 486.32V398.66"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M771.81 578.13V622.18C771.81 627.7 767.33 632.18 761.81 632.18H682.38C676.86 632.18 672.38 627.7 672.38 622.18V397.64"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M672.38 427.8V453.51C672.38 459.03 676.86 463.51 682.38 463.51H720.34C725.86 463.51 730.34 459.03 730.34 453.51V268.51C730.34 262.99 734.82 258.51 740.34 258.51H845.96C851.48 258.51 855.96 262.99 855.96 268.51V327.67"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M749.9 496.33H768.09C773.61 496.33 778.09 491.85 778.09 486.33V457.43"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M752.36 496.33H826.24C831.76 496.33 836.24 491.85 836.24 486.33V457.43"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M400.73 297.66H538.98C544.5 297.66 548.98 302.14 548.98 307.66V453.5C548.98 459.02 553.46 463.5 558.98 463.5H662.37C667.89 463.5 672.37 459.02 672.37 453.5V402.13"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M785.86 725.71H827C828.657 725.71 830 724.367 830 722.71V658.03C830 656.373 828.657 655.03 827 655.03H785.86C784.203 655.03 782.86 656.373 782.86 658.03V722.71C782.86 724.367 784.203 725.71 785.86 725.71Z"
          fill="#BCBEC0"
        />
        <path
          d="M819.98 704.95V762.7H792.88V704.95C792.88 697.47 798.95 691.4 806.43 691.4C813.91 691.4 819.98 697.47 819.98 704.95V704.95Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1285.57 748.57H154.43V777.75H1285.57V748.57Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M154.43 811.37H1285.57"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M828.64 772.41H817.72V783.33H828.64V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M823.18 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M570.44 772.41H559.52V783.33H570.44V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M564.98 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1086.84 772.41H1075.92V783.33H1086.84V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1081.38 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M312.24 772.41H301.32V783.33H312.24V772.41Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M306.78 783.33V811.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1285.57 78.48H154.43V107.66H1285.57V78.48Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M348.25 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M342.79 162.45H353.71V64.4401H342.79V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1122.85 64.44V36.4"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1117.4 162.45H1128.32V64.4401H1117.4V162.45Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1234.32 832.1H1288.68V34.32H1234.32V832.1Z"
          fill="url(#paint0_linear_865_87)"
        />
        <path
          d="M1294.7 83.76V29.4L143.69 29.4V83.76L1294.7 83.76Z"
          fill="url(#paint1_linear_865_87)"
        />
        <path
          d="M857.39 520.99H867.11"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M872.3 515.81V506.09"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1024.57 506.09V515.81"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1029.76 500.91H1039.48"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M285.21 107.66V522.55H403.64V480.43H393.27V470.71H403.64C409.01 470.71 413.36 475.06 413.36 480.43V522.55C413.36 527.92 409.01 532.27 403.64 532.27H282.49C278.62 532.27 275.49 529.14 275.49 525.27V107.66H285.21V107.66Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M344.71 480.43H314.17C310.3 480.43 307.17 477.3 307.17 473.43V155.22H316.89V470.71H344.7V480.43H344.71Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M962.01 198.02H951.97V235.69H962.01V198.02Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M967.92 198.02H946.06V235.69H967.92V198.02Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M973.65 157.29V198.02H940.32V157.29H926.6V123.84H987.38V157.29H973.65Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M983.22 121.77H978.38V159.36H983.22V121.77Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M938.25 166.36V171.2H975.72V166.36H938.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M938.25 189.17V194.01H975.72V189.17H938.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M935.59 121.77H930.75V159.36H935.59V121.77Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M964.23 235.69H949.75V248.28H964.23V235.69Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M962.01 198.02H951.97V235.69H962.01V198.02Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M967.92 198.02H946.06V235.69H967.92V198.02Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M973.65 157.29V198.02H940.32V157.29H926.6V123.84H987.38V157.29H973.65Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M983.22 121.77H978.38V159.36H983.22V121.77Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M938.25 166.36V171.2H975.72V166.36H938.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M938.25 189.17V194.01H975.72V189.17H938.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M935.59 121.77H930.75V159.36H935.59V121.77Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M964.23 235.69H949.75V248.28H964.23V235.69Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M952.44 248.28H961.53V374.08C961.53 376.59 959.49 378.63 956.98 378.63C954.47 378.63 952.43 376.59 952.43 374.08V248.28H952.44Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M953.44 136.11H955.29V139.43H958.7V136.11H960.55V144.51H958.7V141.14H955.29V144.51H953.44V136.11Z"
          fill="#FF0000"
        />
        <path
          d="M1045.32 150.58H1023.46V188.25H1045.32V150.58Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1051.28 109.85V150.58H1017.95V109.85H1004.23V76.3999H1065.01V109.85H1051.28Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1060.85 74.33H1056.01V111.92H1060.85V74.33Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1015.88 118.92V123.76H1053.35V118.92H1015.88Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1015.89 141.73V146.57H1053.36V141.73H1015.89Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1013.22 74.33H1008.38V111.92H1013.22V74.33Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1041.63 188.25H1027.15V200.84H1041.63V188.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1039.48 200.84H1029.76V210H1039.48V200.84Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1045.32 150.58H1023.46V188.25H1045.32V150.58Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1051.28 109.85V150.58H1017.95V109.85H1004.23V76.3999H1065.01V109.85H1051.28Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1060.85 74.33H1056.01V111.92H1060.85V74.33Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1015.88 118.92V123.76H1053.35V118.92H1015.88Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1015.89 141.73V146.57H1053.36V141.73H1015.89Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1013.22 74.33H1008.38V111.92H1013.22V74.33Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1041.63 188.25H1027.15V200.84H1041.63V188.25Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1030.74 91.98V91.96C1030.74 89.57 1032.54 87.62 1035.12 87.62C1036.7 87.62 1037.65 88.15 1038.43 88.91L1037.26 90.27C1036.61 89.68 1035.95 89.32 1035.11 89.32C1033.69 89.32 1032.68 90.49 1032.68 91.93V91.95C1032.68 93.39 1033.68 94.59 1035.11 94.59C1036.07 94.59 1036.66 94.21 1037.32 93.61L1038.5 94.8C1037.64 95.72 1036.68 96.3 1035.06 96.3C1032.59 96.3 1030.75 94.39 1030.75 91.98H1030.74Z"
          fill="#003DA6"
        />
        <path
          d="M206.72 34.3199H152.36V832.1H206.72V34.3199Z"
          fill="url(#paint2_linear_865_87)"
        />
        <path
          d="M961.53 313.2H952.44V330.17H961.53V313.2Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1039.48 422.87H1029.76V439.84H1039.48V422.87Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1025.21 431.36H901.97C876.46 431.36 855.79 410.68 855.79 385.18V361.01"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M947.9 321.69C931.95 321.69 919.02 334.62 919.02 350.57V365.49C919.02 392.37 897.23 414.15 870.36 414.15C843.48 414.15 821.7 392.36 821.7 365.49V361.01"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
        />
        <path
          d="M952.45 317.35H947.9V326.02H952.45V317.35Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1029.76 427.02H1025.21V435.69H1029.76V427.02Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M838.86 319.01V399.87C838.86 423.41 826.56 445.23 806.43 457.43"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M368.98 320.99V446.67"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter13_d_865_87)">
          <path
            d="M350.12 470.39H344.7V480.57H350.12V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M350.12 477.46H344.7"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M344.7 473.5H350.12"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M354.54 472.18H350.12V478.78H354.54V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M387.83 472.18H383.41V478.78H387.83V472.18Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M361.95 470.39H354.54V480.57H361.95V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M383.41 470.39H376V480.57H383.41V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M376 470.39H361.95V490.34H376V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M376 464.14H361.95V470.39H376V464.14Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M374.15 457.88H363.81V464.13H374.15V457.88Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M372.04 453.17H365.92V457.88H372.04V453.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M374.42 446.67H363.53V453.17H374.42V446.67Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M366.41 453.17V446.67"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M371.54 446.67V453.17"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M374.15 490.34H363.81V493.5H374.15V490.34Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M372.04 493.5H365.92V495.95H372.04V493.5Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M393.28 470.39H387.86V480.57H393.28V470.39Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M393.28 477.46H387.86"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M387.86 473.5H393.28"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M368.98 272.16C368.98 235.8 398.45 206.33 434.81 206.33H469.15"
          stroke="black"
          stroke-width="5"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <g filter="url(#filter14_d_865_87)">
          <path
            d="M373.85 316.34H364.1V320.99H373.85V316.34Z"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M400.73 280.1H382.25V297.66H400.73V280.1Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M397.62 280.1V297.66"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M382.24 282.17H377.46V295.59H382.24V282.17Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M362.01 272.16V280.44L355.01 272.95L346.14 281.82L362.01 299.16H377.46V272.16H362.01Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M375.69 299.16H362.01V305.26H375.69V299.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M373.85 311.69H364.1V316.34H373.85V311.69Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M372.18 305.27H365.76V311.69H372.18V305.27Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M377.46 297.75L373.58 294.64V277.53L377.46 274.42V297.75Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M363.67 289.82H373.59V292.81H363.67C362.85 292.81 362.18 292.14 362.18 291.32C362.18 290.5 362.85 289.83 363.67 289.83V289.82Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M371.14 272.16H365.25V281.72H371.14V272.16Z"
            fill="#F7FAFC"
            stroke="black"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M307.17 466.57H316.89"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M321.04 470.71V480.43"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M275.49 518.4H285.21"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M289.36 522.54V532.27"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M399.5 532.27V522.54"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M403.65 518.4H413.37"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M413.37 484.51H403.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M399.5 480.37V470.65"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M796.74 258.51H811.67C817.19 258.51 821.67 262.99 821.67 268.51V330.24"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M775.8 588.27V646.5C775.8 652.02 771.32 656.5 765.8 656.5H626.85"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M566.88 656.51H666.16C667.38 656.51 668.37 655.52 668.37 654.3V395.65L674.42 388.22V359.63"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter15_d_865_87)">
          <path
            d="M579.15 658.55H584.3V700.84C584.3 702.5 582.96 703.84 581.3 703.84H533.93C532.55 703.84 531.43 702.72 531.43 701.34V653.97C531.43 652.31 532.77 650.97 534.43 650.97H581.3C582.96 650.97 584.3 652.31 584.3 653.97V654.47H579.15C578.02 654.47 577.11 655.38 577.11 656.51C577.11 657.64 578.02 658.55 579.15 658.55V658.55Z"
            fill="#F7FAFC"
          />
          <path
            d="M579.15 658.55H584.3V700.84C584.3 702.5 582.96 703.84 581.3 703.84H533.93C532.55 703.84 531.43 702.72 531.43 701.34V653.97C531.43 652.31 532.77 650.97 534.43 650.97H581.3C582.96 650.97 584.3 652.31 584.3 653.97V654.47H579.15C578.02 654.47 577.11 655.38 577.11 656.51C577.11 657.64 578.02 658.55 579.15 658.55V658.55Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter16_d_865_87)">
          <path d="M574.33 690.35V664.46H541.41V690.35H574.33Z" fill="#F7FAFC" />
          <path
            d="M574.33 690.35V664.46H541.41V690.35H574.33Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M569.33 685.35V669.46H546.41V685.35H569.33Z"
          fill="black"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M536.93 700.34C538.057 700.34 538.97 699.427 538.97 698.3C538.97 697.173 538.057 696.26 536.93 696.26C535.803 696.26 534.89 697.173 534.89 698.3C534.89 699.427 535.803 700.34 536.93 700.34Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 314.69C675.56 314.69 674.42 317.56 674.42 320.96V352.22"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 318.26C675.56 318.26 674.42 321.13 674.42 324.53V355.79"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 323.4C675.56 323.4 674.42 326.27 674.42 329.67V360.93"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 327.04C675.56 327.04 674.42 329.91 674.42 333.31V364.57"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 330.77C675.56 330.77 674.42 333.64 674.42 337.04V368.3"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M682.76 311.05C675.56 311.05 674.42 313.92 674.42 317.32V348.58"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M852.71 544.04H830.74V561.31H852.71V544.04Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M852.71 542.53H846.5V562.99H852.71V542.53Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter17_d_865_87)">
          <path d="M846.5 540.85H840.13V564.49H846.5V540.85Z" fill="#F7FAFC" />
          <path
            d="M846.5 540.85H840.13V564.49H846.5V540.85Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter18_d_865_87)">
          <path
            d="M814.16 589.94V673.3C814.16 677.57 810.7 681.04 806.42 681.04C802.15 681.04 798.68 677.58 798.68 673.3V589.94H814.15H814.16Z"
            fill="#F7FAFC"
          />
          <path
            d="M814.16 589.94V673.3C814.16 677.57 810.7 681.04 806.42 681.04C802.15 681.04 798.68 677.58 798.68 673.3V589.94H814.15H814.16Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter19_d_865_87)">
          <path
            d="M826.88 540.26V541.81H830.73V563.65H819.66C817.6 563.65 817.31 566 817.31 566V589.88H795.42V586.74C795.42 585.34 794.02 584.39 791.96 584.39H789.65V567.12H790.55C793.42 567.12 792.87 563.65 792.87 563.65H792.9C789.66 561.74 789.82 558.96 789.82 558.96V546.38C789.82 542.22 785.86 540.25 785.86 540.25H826.87L826.88 540.26Z"
            fill="#F7FAFC"
          />
          <path
            d="M826.88 540.26V541.81H830.73V563.65H819.66C817.6 563.65 817.31 566 817.31 566V589.88H795.42V586.74C795.42 585.34 794.02 584.39 791.96 584.39H789.65V567.12H790.55C793.42 567.12 792.87 563.65 792.87 563.65H792.9C789.66 561.74 789.82 558.96 789.82 558.96V546.38C789.82 542.22 785.86 540.25 785.86 540.25H826.87L826.88 540.26Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M821.35 540.26L822.9 541.81C822.9 541.81 823.69 546.03 828.4 547.02"
          fill="#F7FAFC"
        />
        <path
          d="M821.35 540.26L822.9 541.81C822.9 541.81 823.69 546.03 828.4 547.02"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M826.88 541.81C826.88 541.81 829.03 547.13 829.03 552.67C829.03 558.21 827.55 562.14 827.55 562.14V563.65"
          fill="#F7FAFC"
        />
        <path
          d="M826.88 541.81C826.88 541.81 829.03 547.13 829.03 552.67C829.03 558.21 827.55 562.14 827.55 562.14V563.65"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M821.26 563.66H792.98"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M822.9 541.81H826.88"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter20_d_865_87)">
          <path
            d="M864.12 570.57H860.39V574.98H864.12V570.57Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M862.26 574.98H872.57V577.15C872.57 579.32 862.26 579.97 862.26 579.97C862.26 579.97 851.95 579.32 851.95 577.15V574.98H862.26Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M862.26 574.98H868.07V577.15C868.07 579.32 862.26 579.97 862.26 579.97C862.26 579.97 856.45 579.32 856.45 577.15V574.98H862.26Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M862.26 579.97V574.98"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M868.92 566.44H855.06V570.57H868.92V566.44Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M862 539.27H853.21C853.21 539.27 850.42 544.94 850.42 552.86C850.42 560.78 853.21 566.45 853.21 566.45H870.78C870.78 566.45 873.57 560.78 873.57 552.86C873.57 544.94 870.78 539.27 870.78 539.27H861.99H862Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M868.92 535.14H855.06V539.27H868.92V535.14Z"
            fill="#F7FAFC"
            stroke="#414042"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M783.91 587.97H789.67V565.22H783.91V587.97Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M780.39 584.47H783.9V567.13H780.39V584.47Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter21_d_865_87)">
          <path
            d="M762.7 597.4H780.39V565.21H764.77V580.3C764.77 583.81 762.7 583.18 762.7 586.58V597.4V597.4Z"
            fill="#F7FAFC"
          />
          <path
            d="M762.7 597.4H780.39V565.21H764.77V580.3C764.77 583.81 762.7 583.18 762.7 586.58V597.4V597.4Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter22_d_865_87)">
          <path
            d="M817.33 589.88C817.33 589.88 818.91 590.5 818.91 590.89V602.46H793.86V590.89C793.86 590.51 795.44 589.88 795.44 589.88H817.33V589.88Z"
            fill="#F7FAFC"
          />
          <path
            d="M817.33 589.88C817.33 589.88 818.91 590.5 818.91 590.89V602.46H793.86V590.89C793.86 590.51 795.44 589.88 795.44 589.88H817.33V589.88Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M802.49 602.45V596.92C802.49 596.92 804 596.16 806.39 596.16C808.78 596.16 810.29 596.92 810.29 596.92V602.45"
          fill="#F7FAFC"
        />
        <path
          d="M802.49 602.45V596.92C802.49 596.92 804 596.16 806.39 596.16C808.78 596.16 810.29 596.92 810.29 596.92V602.45"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M794.52 602.45V596.92C794.52 596.92 795.59 596.16 797.29 596.16C798.99 596.16 800.06 596.92 800.06 596.92V602.45"
          fill="#F7FAFC"
        />
        <path
          d="M794.52 602.45V596.92C794.52 596.92 795.59 596.16 797.29 596.16C798.99 596.16 800.06 596.92 800.06 596.92V602.45"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M812.62 602.45V596.92C812.62 596.92 813.69 596.16 815.39 596.16C817.09 596.16 818.16 596.92 818.16 596.92V602.45"
          fill="#F7FAFC"
        />
        <path
          d="M812.62 602.45V596.92C812.62 596.92 813.69 596.16 815.39 596.16C817.09 596.16 818.16 596.92 818.16 596.92V602.45"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M795.87 522.78H817.43V518.75H795.87V522.78Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <g filter="url(#filter23_d_865_87)">
          <path
            d="M782.15 540.26V531.3C782.15 527.22 785.43 523.79 789.79 523.27C793.9 522.78 799.58 522.33 806.65 522.33C813.72 522.33 819.4 522.78 823.51 523.27C827.87 523.79 831.15 527.22 831.15 531.3V540.26H782.15Z"
            fill="#F7FAFC"
          />
          <path
            d="M782.15 540.26V531.3C782.15 527.22 785.43 523.79 789.79 523.27C793.9 522.78 799.58 522.33 806.65 522.33C813.72 522.33 819.4 522.78 823.51 523.27C827.87 523.79 831.15 527.22 831.15 531.3V540.26H782.15Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_865_87"
            x="615.12"
            y="293.84"
            width="84"
            height="106.8"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_865_87"
            x="782.76"
            y="296.93"
            width="110.42"
            height="73.02"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_865_87"
            x="799.7"
            y="296.74"
            width="76.54"
            height="82.95"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_865_87"
            x="848.96"
            y="304.93"
            width="11.6699"
            height="58.5"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter4_d_865_87"
            x="814.83"
            y="304.93"
            width="11.6699"
            height="58.5"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter5_d_865_87"
            x="803.91"
            y="314.93"
            width="67.89"
            height="10.16"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter6_d_865_87"
            x="809.52"
            y="308.84"
            width="22.34"
            height="22.34"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter7_d_865_87"
            x="843.71"
            y="308.84"
            width="22.34"
            height="22.34"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter8_d_865_87"
            x="831.15"
            y="312.55"
            width="13.4401"
            height="14.91"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter9_d_865_87"
            x="840.63"
            y="333.28"
            width="28.64"
            height="24.92"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter10_d_865_87"
            x="841.99"
            y="332.78"
            width="25.9199"
            height="25.92"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter11_d_865_87"
            x="806.36"
            y="333.28"
            width="28.64"
            height="24.92"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter12_d_865_87"
            x="807.73"
            y="332.78"
            width="25.92"
            height="25.92"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter13_d_865_87"
            x="342.2"
            y="446.17"
            width="51.58"
            height="52.28"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter14_d_865_87"
            x="343.64"
            y="271.66"
            width="57.59"
            height="51.8301"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter15_d_865_87"
            x="528.43"
            y="649.97"
            width="56.87"
            height="56.8701"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter16_d_865_87"
            x="538.41"
            y="663.46"
            width="36.92"
            height="29.89"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter17_d_865_87"
            x="837.13"
            y="539.85"
            width="10.37"
            height="27.64"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter18_d_865_87"
            x="795.68"
            y="588.94"
            width="19.48"
            height="95.1"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter19_d_865_87"
            x="782.86"
            y="539.25"
            width="48.8701"
            height="53.63"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter20_d_865_87"
            x="847.42"
            y="534.14"
            width="27.15"
            height="48.83"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter21_d_865_87"
            x="759.7"
            y="564.21"
            width="21.6899"
            height="36.19"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter22_d_865_87"
            x="790.86"
            y="588.88"
            width="29.05"
            height="16.58"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <filter
            id="filter23_d_865_87"
            x="779.15"
            y="521.33"
            width="53"
            height="21.93"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_865_87"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_865_87"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_865_87"
            x1="1288.67"
            y1="433.2"
            x2="1234.31"
            y2="433.2"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_865_87"
            x1="719.2"
            y1="29.39"
            x2="719.2"
            y2="83.76"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_865_87"
            x1="152.36"
            y1="433.22"
            x2="206.72"
            y2="433.22"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </template>
  </Configuration>
</template>

<script>
export default {
  name: 'ConfigurationBack',
  data: () => ({
    items: [
      {
        label: 'Manifold',
        value: 'manifold',
        x: 644,
        y: 166,
        title: 'Manifolds',
        content: 'Mixes incoming hot and cold water supply for showers and sinks.',
        link: '/commercial-bathroom-products/water-technology/manifolds',
        linkText: 'View PWT Manifolds'
      },
      {
        label: 'Solenoid',
        value: 'solenoid',
        x: 346,
        y: 166,
        title: 'Solenoids',
        content: 'Electronically control water run-times to lavatory and shower fixtures.',
        link: '/commercial-bathroom-products/water-technology/solenoids',
        linkText: 'View PWT Solenoids'
      },
      {
        label: 'Flushometer',
        value: 'flushometer',
        x: 776,
        y: 261,
        title: 'PWT Flushometers',
        content:
          'Tamper-resistant and and environmentally-friendly, our flushometers are available as hardwired or battery-operated fixtures.',
        link: '/commercial-bathroom-products/water-technology/flushometers',
        linkText: 'View PWT Flushometers'
      },
      {
        label: 'PWT Controller',
        value: 'controller',
        x: 499,
        y: 166,
        title: 'PWT Controllers',
        content:
          'The nerve center of our PWT systems that allows control over lavatories, water closets, showers, or combination fixtures.',
        link: '/commercial-bathroom-products/pwt/microplumb-controllers',
        linkText: 'View PWT Controllers'
      },
      {
        label: 'PWT Transformers',
        value: 'transformer',
        x: 478,
        y: 280,
        title: 'PWT Transformers',
        content: 'Power multiple combinations of fixtures.',
        link: '/commercial-bathroom-products/pwt/transformers',
        linkText: 'View PWT Transformers'
      }
    ]
  })
};
</script>
